<template>
  <div class="side-bar">
    <!-- :span="23" -->
    <el-col style="width:100%;">
      <el-menu
        :default-active="active_index"
        class="el-menu-vertical-demo"
        background-color="#fff"
        text-color="#999999"
        active-text-color="#00CB9F"
        active-background-color="#00CB9F"
        router
      >
        <el-menu-item
          v-for="item in menu_data"
          :index="item.index"
          :key="item.index"
          style="padding-left: 30px;text-align:left;"
          @click="active_index=item.index"
          v-show="checkShow(item)"
        >
          <div class="menu_content">
            <div class="menu_back" :class="checkIsPath(item.index)?'menu_active_back':''"></div>
            <img
              class="menu_icon"
              v-bind:src="menu_set.path+item.icon+(checkIsPath(item.index)?menu_set.end:'')+menu_set.format"
            />
            <span slot="title">{{item.name}}</span>
          </div>
        </el-menu-item>
      </el-menu>
    </el-col>
  </div>
</template>
<script>
export default {
  data() {
    return {
      user: null,
      //wantToPath: "",
      //identityType: sessionStorage.getItem("youridentity"),
      // 默认选中的菜单 index 或选中的菜单 index
      active_index: "/home",
      // 菜单设置
      menu_set: {
        path: "../../../static/images/",
        end: "_ed",
        format: ".png"
      },
      // 菜单数据
      /**
       * index: 路由
       * icon: 菜单前的图片，不选中的图片
       * name: 菜单名称
       * show: 是否显示，false 则都不显示
       * roleType: 角色权限，数字越大，需要的权限越小， 1 超级管理员才能访问，2 管理员就能访问，3 店主可以访问
       */
      menu_data: [
        {
          index: "/home",
          icon: "tab_home",
          name: "首页",
          show: true
        },
        {
          index: "/admin",
          icon: "tab_administrator",
          name: "管理员",
          role: "adminManage",
          show: false
        },
        {
          index: "/user",
          icon: "tab_user",
          name: "用户管理",
          role: "userManage",
          show: true
        },
        {
          index: "/device",
          icon: "tab_equipment",
          name: "设备管理",
          role: "deviceManage",
          show: true
        },
        {
          index: "/tutorial",
          icon: "tab_classification",
          name: "学院管理",
          role: "tutorialManage",
          show: true
        },
        {
          index: "/enterpriseLog",
          icon: "tab_order",
          name: "操作日志",
          role: "enterpriseLog",
          show: true
        }
      ]
    };
  },
  created() {
    //this.wantToPath = localStorage.getItem("toVisitPath");
    this.active_index = localStorage.getItem("toVisitPath");
    //console.log("--这里--"+this.active_index+"-")

    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.user.roleType = this.user.type;
    if(this.user.type == 1){
      this.menu_data[1].show = true;
    }
  },
  mounted() {},
  methods: {
    // 判断要不要显示
    checkShow(item){
      console.log(item)
      // 为空
      if(!item){
        return false;
      }
      // 不需要角色
      if(!item.role){
        return true;
      }

      //console.log("jru = "+item.role,this.user.jurisdictions.indexOf(item.role))
      // if(this.user.jurisdictions.indexOf(item.role) >= 0){
      //   return true;
      // }
      return true;
    },
    // 检查是不是当前菜单，用于选中
    checkIsPath(path) {
      // 判断当前页面是不是下级页面
      if (path.length < this.active_index.length) {
        // 是下级页面，判断是不是该子页面
        if (this.active_index.substring(0, path.length) == path) {
          // 去前缀重复处理，前缀重复，但子页面以 / 隔开，不是的则不是以 / 隔开
          if (path.length < this.active_index.length) {
            var p = this.active_index.substring(path.length, path.length + 1);
            if (p == "/") {
              return true;
            }
          } else {
            return true;
          }
        }
      }else if(path.length == this.active_index.length && path == this.active_index){
        // 不是下级，且等当前页面
        return true;
      }
      return false;
    }
  }
};
</script>
<style scoped>
.side-bar {
  /* width: 100%;
  max-width: 158px; */
  width: 188px;
  height: 100%;
  background: #fff;
}

.menu_icon {
  width: 24px;
  height: 24px;
  margin-right: 5px;
}
.menu_content {
  position: relative;
}
.menu_back {
  position: absolute;
  left: -30px;
  top: 0px;
  height: 56px;
  width: calc(100% + 50px);
}
.menu_active_back {
  opacity: 0.1;
  background: #00cb9f;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/sidebar.vue